import { getAddSupplierModalOpened } from '@bridebook/web/lib/shortlist/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const AddSupplierModal = lazyComponent(() => import('./add-supplier-modal'));

interface AddSupplierModalLazyProps {}

const AddSupplierModalLazy: React.FC<AddSupplierModalLazyProps> = () => {
  const show = useSelector(getAddSupplierModalOpened);

  if (!show) {
    return null;
  }

  return <AddSupplierModal />;
};

export default memo(AddSupplierModalLazy);
